import { createApi } from '@redux/createApi';
import { createSlice } from '@reduxjs/toolkit';
import { serialize } from '../../../shared/lib/serialize';
import { format } from '../../../shared/lib/format';

const tags = {
  getBlockLog: 'getBlockLog',
};

const formatDateParam = (date) =>
  `${format.addZeroBefore(date.getDate())}/${format.addZeroBefore(date.getMonth() + 1)}/${date.getFullYear()}`;

export const blockLogApi = createApi({
  reducerPath: 'blockLogApi',
  tagTypes: [tags.getBlockLog],
  endpoints: (builder) => ({
    getBlockLog: builder.query({
      query: (queryParams) => {
        const [start, end] = queryParams;

        let params = {};

        if (start) {
          params = { ...params, date_from: formatDateParam(start) };
        }

        if (end) {
          params = { ...params, date_to: formatDateParam(end) };
        }

        const queryString = serialize(params);
        return { url: `/admin/block-log?${queryString}`, method: 'GET' };
      },
      providesTags: [tags.getBlockLog],
    }),
  }),
});

export const { useGetBlockLogQuery } = blockLogApi;

// Slice for managing date filter parameters
const initialState = {
  start: (() => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  })(),
  end: new Date(),
};

export const blockLogParamsSlice = createSlice({
  name: 'blockLogParams',
  initialState,
  reducers: {
    setParams: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetParams: () => initialState,
  },
});

export const { setParams, resetParams } = blockLogParamsSlice.actions;
export const blockLogParamsReducer = blockLogParamsSlice.reducer;
export const blockLogParamsSelector = (state) => state.blockLogParams;
